import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/accordion'
import { Box, Flex, VStack } from '@chakra-ui/layout'
import {
  Grid,
  GridItem,
  Icon,
  Link,
  Text as ChakraText,
} from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RiChatSettingsLine } from 'react-icons/ri'
import { sdkIcons } from '../../../../graphics/UrlEndpoints'
import RunInPostman from '../../../../graphics/RunInPostman'

export const sdkMappings: {
  [sdkName: string]: {
    title: string
    link: string
  }
} = {
  react: {
    title: 'React',
    link: 'https://imagekit.io/docs/integration/react',
  },
  nextjs: {
    title: 'Next.js',
    link: 'https://imagekit.io/docs/integration/nextjs',
  },
  angular: {
    title: 'Angular',
    link: 'https://imagekit.io/docs/integration/angular',
  },
  android: {
    title: 'Android',
    link: 'https://imagekit.io/docs/integration/android',
  },
  iOS: {
    title: 'iOS',
    link: 'https://imagekit.io/docs/integration/ios',
  },
  netlify: {
    title: 'Netlify',
    link: 'https://imagekit.io/docs/integration/netlify',
  },
  javascript: {
    title: 'JavaScript',
    link: 'https://github.com/imagekit-developer/imagekit-javascript',
  },
  vuejs: {
    title: 'Vue.js',
    link: 'https://imagekit.io/docs/integration/vuejs',
  },
  nodejs: {
    title: 'Node.js',
    link: 'https://github.com/imagekit-developer/imagekit-nodejs',
  },
  python: {
    title: 'Python',
    link: 'https://imagekit.io/docs/integration/python',
  },
  php: {
    title: 'PHP',
    link: 'https://imagekit.io/docs/integration/php',
  },
  dotNet: {
    title: '.NET',
    link: 'https://github.com/imagekit-developer/imagekit-dotnet',
  },
  java: {
    title: 'Java',
    link: 'https://imagekit.io/docs/integration/java',
  },
  ror: {
    title: 'ROR',
    link: 'https://imagekit.io/docs/integration/ruby',
  },
  shopify: {
    title: 'Shopify',
    link: 'https://imagekit.io/docs/integration/shopify',
  },
  wordpress: {
    title: 'Wordpress',
    link: 'https://imagekit.io/docs/integration/wordpress',
  },
  magento: {
    title: 'Magento',
    link: 'https://imagekit.io/docs/integration/magento',
  },
}

const DocumentationAPIandSDKs = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <AccordionItem>
      <AccordionButton px={12} py={8}>
        <Flex flex="1" textAlign="left" fontWeight="bold">
          <Icon as={RiChatSettingsLine} boxSize={6} mr={4} />
          {t('support_api_and_sdks')}
        </Flex>
        <Box background="appPaleGreyThree" borderRadius="full" padding={1}>
          <AccordionIcon color="appSlate" display="block" />
        </Box>
      </AccordionButton>

      <AccordionPanel px={12} py={8}>
        <VStack
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={14}
        >
          <Grid gridTemplateColumns="repeat(7, 1fr)" gap={6} rowGap={12}>
            {Object.keys(sdkMappings).map(key => {
              const obj = sdkMappings[key]
              const IconComponent = sdkIcons[key]
              return (
                <Link
                  _hover={{ textDecoration: 'none' }}
                  isExternal
                  color="currentcolor"
                  key={obj.title}
                  href={obj.link}
                >
                  <GridItem key={obj.title}>
                    <VStack spacing={4}>
                      <Icon as={IconComponent} boxSize={10} />
                      <ChakraText color="appSlate">{obj.title}</ChakraText>
                    </VStack>
                  </GridItem>
                </Link>
              )
            })}
          </Grid>

          <Link
            _focus={{ textDecoration: 'none', outline: 'none' }}
            isExternal
            href="https://god.gw.postman.com/run-collection/e8afe4815e95f8b14660"
          >
            <RunInPostman h={10} w={40} />
          </Link>
        </VStack>
      </AccordionPanel>
    </AccordionItem>
  )
}

export default DocumentationAPIandSDKs
